import { create } from 'apisauce';

const authResultKey = 'vrpatients::auth::result';
const authResult = JSON.parse(localStorage.getItem(authResultKey));

const servicesClient = create({
  baseURL: `${process.env.VUE_APP_CASES_SERVICE_URL}/services`,
  headers: {
    Authorization: authResult ? `Bearer ${authResult.idToken}` : undefined,
  },
});

servicesClient.addResponseTransform((response) => {
  if (!response.ok) {
    throw response.data || new Error('No response from server');
  }
});

export default servicesClient;
